import { useState } from "react";
import { useAppDispatch } from "../../redux/hooks";
import { BasicInfoTab } from "./BasicInfoTab";
import { SpecTab } from "./SpecTab";
import { VariantTab } from "./VariantTab";
import { DescriptionTab } from "./DescriptionTab";
import { useProductForm } from "../../contexts/ProductFormContext";
import { SeoTab } from "./SeoTab";
import { createProduct } from "../../redux/slices/productSlice";
import { toast } from "react-toastify";
import { getErrorMessage } from "../../utils/errorHandler";
import { validateForm } from "../../utils/validateForm";
import Lottie from "lottie-react";
import buttonLoading from "../../animations/buttonLoading.json";

type Payload = {
  onBack: () => void;
};
export const CreateProductContent = ({ onBack }: Payload) => {
  const { product, resetForm } = useProductForm();
  const dispatch = useAppDispatch();
  const [isSubmit, setIsSubmit] = useState<boolean>(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const valid = validateForm([
      { value: product.product.name, label: "Tên sản phẩm" },
      { value: product.product.categoryId, label: "Danh mục" },
      { value: product.product.brandId, label: "Thương hiệu" },
      { value: product.product.images, label: "Ảnh sản phẩm", type: "array" },
      { value: product.product.description, label: "Mô tả sản phẩm" },
      { value: product.variants, label: "Biến thể sản phẩm", type: "array" },
    ]);
    if (!valid) return;
    setIsSubmit(true);
    try {
      await dispatch(createProduct(product)).unwrap();
      toast.success("Tạo sản phẩm thành công");
      onBack();
    } catch (error) {
      toast.error(getErrorMessage(error));
    } finally {
      setIsSubmit(false);
    }
  };

  return (
    <div className="p-5 space-y-2">
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={onBack}
          className="text-sm text-blue-500 hover:underline cursor-pointer transition-colors duration-300"
        >
          Quản lý sản phẩm
        </button>
        <p className="text-sm text-gray-700">/</p>
        <p className="text-sm text-gray-700">Thêm sản phẩm</p>
      </div>
      <form onSubmit={handleSubmit} className="space-y-2">
        <BasicInfoTab />
        <SpecTab />
        <VariantTab />
        <DescriptionTab />
        <SeoTab />
        <div className="flex items-center justify-between">
          <div className="">
            <button
              type="button"
              onClick={onBack}
              className="p-2 text-sm text-white bg-blue-500 rounded-lg cursor-pointer hover:bg-blue-600 transition-colors duration-300"
            >
              Quay lại
            </button>
          </div>
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={() => {
                resetForm();
              }}
              className="p-2 text-sm text-white bg-red-500 rounded-lg cursor-pointer hover:bg-red-600 transition-colors duration-300"
            >
              Hủy
            </button>
            {isSubmit ? (
              <Lottie
                animationData={buttonLoading}
                loop={true}
                className="h-10 w-20"
              />
            ) : (
              <button
                type="submit"
                className="p-2 text-sm text-white bg-green-500 rounded-lg cursor-pointer hover:bg-green-600 transition-colors duration-300"
              >
                Thêm sản phẩm
              </button>
            )}
          </div>
        </div>
      </form>
    </div>
  );
};
